<template>
  <div class="white-card">
    <div class="loader absolute" v-if="loading && !stats"></div>
    <div class="d-flex">
      <div class="mt-1">
        <img src="@img/trophy.svg" alt="trophy" class="img-fluid">
      </div>
      <div class="ml-3">
        <span>
          Rang general
        </span>
        <div class="d-flex flex-column justify-content-center bg-layer p-2 mt-1">
          <span v-if="stats" class="fw-300 mt-n2">
            {{ stats.rank + 'e / ' + stats.total }}
          </span>
          <div class="text-green font-weight-bold text-capitalize d-flex align-items-end pr-3 mt-n3">
            <strong v-if="stats" class="fz-48 mb-n3 mr-1">{{ stats.score }}</strong> pts
          </div>
        </div>
      </div>
    </div>
    <router-link :to="{name: 'ranking'}" href="#" class="btn btn-block bg-layer rounded-4 mt-4">Classement</router-link>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  components: {},
  computed: {
    ...mapGetters({'stats': 'dashboard/stats', 'loading': 'dashboard/loading'})
  }
};
</script>

<style lang="scss" scoped>
.top {
  margin-bottom: 10px;
  background: white;
  padding: 10px;
  border-radius: 10px;
  /* width: 18%; */
  /* border: 1px solid red; */
  .top__child {
    display: flex;
    /* justify-content: space-between; */
    .top__child__image {
      width: 70px;
      display: flex;
      justify-content: center;
      padding: 5px;
      margin-bottom: 10px;

      img {
        width: 100%;
      }
    }

    .top__child__details {
      div {
        &:nth-child(1) {
          color: #158eda;
        }

        &:nth-child(2) {
          color: #009894;
          font-size: 30px;
        }
      }

    }
  }

  button {
    width: 100%;
    color: white;
    background: #ff8500;
    padding: 5px 0;
    border-radius: 100px;
    outline: none;
    border: transparent;
  }

}
</style>
